export default __webpack_public_path__ + "static/media/pbl-icon.9a922e5e.svg";